// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"7285929c","977":"f9496c72"}[chunkId] + ".chunk.js";
};